import React, {useEffect, useState} from 'react';
import Typography from '@mui/material/Typography';
import Button from "@mui/material/Button";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";



export default function ListOfCourses() {
    const descriptionCourse = [
        {
            index: 6,
            linkToTilda: '/alfa',
            title: 'Формирование лидера',
            greenTitle: '',
            subTitle: 'Авторская методика Елены Корневой для родителей детей 5–12 лет',
            showBF: true,
            img: require("../../img/ImageCards/card-alfa.png"),
            description:
                '<div>\n' +
                '<h3>Из «тени» — в лидеры за 21 день</h3>' +
                '<p>Сформируйте внутренний стержень ребенка.<br>Программа, где мы не просто учим «давать сдачи», а меняем ДНК отношений в семье, чтобы ваш ребенок стал естественным лидером в любом коллективе.</p>\n' +
                '<h3>Что меняется за 21 день:</h3>\n' +
                '<ul style="margin-left: 12px">' +
                '<li>Ребенок сам отстаивает границы</li>\n' +
                '<li>Исчезает страх перед коллективом</li>\n' +
                '<li>Появляется уверенность в себе</li>\n' +
                '<li>Семейные отношения укрепляются</li>\n' +
                '<li>Лидерские качества проявляются естественно</li>\n' +
                '</ul>' +
                '<h3>Почему обычные тренинги не работают?</h3>\n' +
                '<p>Они учат ребенка «казаться», а не «быть». Мы работаем через трансформацию семьи: убираем родительские установки, которые «гасят» энергию ребенка, даем инструменты влияния на уровне психофизики и создаем среду, где лидерство — естественное состояние.</p>\n' +
                '<h3>Формат занятий:</h3>\n' +
                '<ul style="margin-left: 12px">' +
                '<li>Ежедневные видео-уроки (15–20 минут)</li>\n' +
                '<li>60+ практических упражнений</li>\n' +
                '<li>Чек-листы и рабочие тетради</li>\n' +
                '<li>Обратная связь от куратора (тариф «АЛЬФА-ПРО»)</li>\n' +
                '</ul>' +
                '</div>',
            linkIn: '/alfaLeader',
            linkLanding: '',
            access: false
        },
        {
            index: 7,
            linkToTilda: '/speakCourse',
            title: 'Запуск и развитие речи',
            greenTitle: '',
            subTitle: 'Авторская методика для родителей детей от 1,5 до 4 лет',
            showBF: true,
            img: require("../../img/ImageCards/speak-course.png"),
            description:
                '<div>\n' +
                '<h3>От жестов и звуков — к живой речи за 30 дней</h3>' +
                '<p>Запустите и развивайте речь малыша без стресса, криков и бесконечного ожидания.<br>Программа, где мы не просто «ждём до 3 лет», а ежедневно работаем с артикуляцией, дыханием, слухом и ритмом — чтобы речь ребёнка запустилась естественно.</p>\n' +
                '<h3>Что меняется за 30 дней:</h3>\n' +
                '<ul style="margin-left: 12px">' +
                '<li>Ребёнок начинает использовать слова вместо жестов</li>\n' +
                '<li>Появляются первые фразы и простые предложения</li>\n' +
                '<li>Формируется правильное речевое дыхание</li>\n' +
                '<li>Активизируются речевые зоны через нейроигры</li>\n' +
                '<li>Вы получаете понятный план занятий на каждый день</li>\n' +
                '</ul>' +
                '<h3>Почему «само пройдёт» — не работает?</h3>\n' +
                '<p>Речь — это не только слова, а сложная связь мышц, дыхания, слуха и мозга. Мы работаем через игровой подход: артикуляционная гимнастика, двигательные нейропрактики, речевое дыхание и чистоговорки. Каждое упражнение — маленький шаг к большому результату.</p>\n' +
                '<h3>Формат занятий:</h3>\n' +
                '<ul style="margin-left: 12px">' +
                '<li>Ежедневные короткие видео-уроки (10–15 минут)</li>\n' +
                '<li>Игровые упражнения и нейропрактики</li>\n' +
                '<li>Чек-листы, карточки и готовые материалы для печати</li>\n' +
                '<li>Видео-оценка прогресса в начале и в конце</li>\n' +
                '<li>Обратная связь от куратора (тариф «РЕЧЬ-ПРО»)</li>\n' +
                '</ul>' +
                '</div>',
            linkIn: '/speakCourse',
            linkLanding: '',
            access: false
        },
        {
            index: 8,
            linkToTilda: 'https://t.me/energy_korneva_bot',
            title: '20 техник мгновенного восстановления',
            greenTitle: '',
            subTitle: '<div>"Просто отдохни" – <strong>не спасет!</strong></div>',
            img: require("../../img/twenty.png"),
            description: `<div class="burnout-solution">
            <p>Выгорание, усталость, нехватка сил – все это не решается обычным отдыхом. Ваш организм работает так, чтобы вы максимально концентрировались на ребенке и минимально – на себе.</p>
            <p>🔹 <strong>Что с этим делать?</strong> Освободить энергию, вернуть ресурс и эмоциональную устойчивость с помощью 20+ проверенных техник мгновенного восстановления. Это не просто расслабление, а работа с причиной усталости, которая даст моментальный эффект.</p>
            <br/>
            <div class="course-features">
                <p>🔹 <strong>В КУРСЕ ВЫ НАЙДЕТЕ:</strong></p>
                <ul style="list-style: none; padding-left: 0;">
                    <li>✔️ <strong>Техники экстренной помощи себе</strong>, которые можно применять здесь и сейчас.</li>
                    <li>✔️ <strong>Быстрые методики восстановления</strong>, не требующие сложных практик и лишнего времени.</li>
                    <li>✔️ <strong>Инструменты</strong>, влияющие на физиологические процессы, чтобы энергия появлялась сама по себе.</li>
                </ul>
            </div>
            <br/>
            <div class="results-section">
                <p>🔹 <strong>ВАШ РЕЗУЛЬТАТ:</strong></p>
                <ul style="list-style: none; padding-left: 0;">
                    <li>✔️ Вы станете более энергичной и ресурсной.</li>
                    <li>✔️ Настроение стабилизируется, а эмоции перестанут «качать» из стороны в сторону.</li>
                    <li>✔️ Быт и рутина перестанут загонять вас в выгорание.</li>
                    <li>✔️ Вы легче переживаете стрессы и сохраняете спокойствие в любых ситуациях.</li>
                    <li>✔️ Материнство больше не кажется марафоном без финиша – у вас появится ощущение легкости и вдохновения.</li>
                </ul>
            </div>`,
            linkIn: '/twenty',
            linkLanding: '',
            access: false
        },
        {
            index: 5,
            linkToTilda: '/hwcourse',
            title: 'Ежедневно развивать малыша',
            greenTitle: '',
            subTitle: 'задания и вебинары для каждого возраста ребенка',
            img: require("../../img/hw-course.png"),
            description:
                '<div>\n' +
                '<h4>Рассылка домашних заданий для детей от 1 до 26 месяцев</h4>\n' +
                '<ul>\n' +
                '<li><strong>С детальными видео и текстовыми заданиями</strong>\n' +
                '<ul>\n' +
                '<li>по развитию речи, двигательной активности и эмоционального интеллекта.</li>\n' +
                '</ul>\n' +
                '</li>\n' +
                '<li><strong>Удобно и доступно</strong>\n' +
                '<ul>\n' +
                '<li>с рассылками в ваш Телеграм-аккаунт теории, тестов, гайдов и домашних заданий.</li>\n' +
                '</ul>\n' +
                '</li>\n' +
                '<li><strong>С адаптированными под возраст ребенка материалами</strong>\n' +
                '<ul>\n' +
                '<li>доступными от 3 недель до 2,5 лет</li>\n' +
                '</ul>\n' +
                '</li>\n' +
                '<li><strong>Без необходимости покупать дополнительное оборудование</strong>\n' +
                '<ul>\n' +
                '<li>все задания выполняются без финансовых затрат</li>\n' +
                '</ul>\n' +
                '</li>\n' +
                '</ul>\n' +
                '</div>',
            linkIn: '/hwcourse',
            linkLanding: '',
            access: false
        }
    ];


    const descriptionCourseOld = [
        {
            index: 6,
            linkToTilda: '/alfa',
            title: 'Формирование лидера',
            greenTitle: '',
            subTitle: 'Проблемы животика и кишечника ребенка от 0 до 6 месяцев',
            showBF: true,
            img: require("../../img/ImageCards/card-image-gray-12.png"),
            description:
                '<div>\n' +
                '<h3 >&nbsp;</h3>' +
                '<h3 >Газики, колики, запоры, какашечки и др.</h3>' +
                '<li>Как работает желудочно-кишечный тракт крохи в период бурного роста и развития?</li>\n' +
                '<li>Когда бежать за помощью, а что является вариантом нормального развития?</li>\n' +
                '<li>Как помочь и не навредить? Какие пробиотики, пребиотики, ферменты и препараты от запоров действительно нужны вашему малышу?</li>\n' +
                '<p>Весь материал - это увлекательное путешествие по организму ребенка с его особенностями и потребностями.</p>\n' +
                '</ul> ' +
                '</div>',
            linkIn: '/diaperMystery',
            linkLanding: '',
            access: false
        },
        {
            index: 0,
            linkToTilda: 'https://landinghw.kornevgmbh.com/',
            title: 'Ежедневно развивать малыша',
            subTitle: 'с <strong>рассылкой</strong> домашних заданий для Вашего возраста',
            img: require("../../img/ImageCards/card-image-gray-1.jpg"),
            description:
                '<h3 >&nbsp;</h3>' +
                '<div>\n' +
                '<h3>Ежедневная рассылка домашних заданий для детей от 1 до 26 месяцев</h3> ' +
                '<ul>\n' +
                '<li><strong>С детальными видео и текстовыми заданиями&nbsp;</strong>\n' +
                '<ul>\n' +
                '<li>по развитию речи, двигательной активности и эмоционального интеллекта.</li>\n' +
                '</ul>\n' +
                '</li>\n' +
                '<li><strong>Удобно и доступно</strong>\n' +
                '<ul>\n' +
                '<li>с рассылками&nbsp; в ваш Телеграм-аккаунт&nbsp; теории, тестов, гайдов и домашних заданий.</li>\n' +
                '</ul>\n' +
                '</li>\n' +
                '<li><strong>С адаптированными под возраст ребенка материалами</strong>\n' +
                '<ul>\n' +
                '<li>доступными&nbsp; от 3 недель до 2,5 лет</li>\n' +
                '</ul>\n' +
                '</li>\n' +
                '<li><strong>Без необходимости покупать дополнительное оборудование</strong>\n' +
                '<ul>\n' +
                '<li>все задания выполняются без финансовых затрат</li>\n' +
                '</ul>\n' +
                '</li>\n' +
                '</ul>' +
                '</div>'
        },
        {
            index: 1,
            linkToTilda: 'https://landing.kornevgmbh.com/',
            title: 'Вырастить успешную личность',
            img: require("../../img/ImageCards/card-image-gray-2.jpg"),
            subTitle: 'с <strong>вебинарами</strong>  по гармоничному  развитию малышей от 0 до 24 месяцев',
            description:
                '<div >\n' +
                '<h3 >&nbsp;</h3>' +
                '<h3>Авторские вебинары по гармоничному развитию детей от от 0 до 24 месяцев</h3> ' +
                '<ul>\n' +
                '<li>Уникальные вебинары с простыми и&nbsp; понятными объяснениями сложных процессов детского развития</li>\n' +
                '<li>Содержат концентрированную и полезную информацию по каждому возрастному периоду</li>\n' +
                '<li>Подробно разъясняют какими действиями Вы можете достичь максимальных результатов в развитии крохи</li>\n' +
                '</ul>\n' +
                '</div>'
        },
        {
            index: 2,
            linkToTilda: 'https://landing-dream.kornevgmbh.com/',
            title: 'Наладить сон ребенка',
            subTitle: '<div>научив его самостоятельному засыпанию с помощью <strong>Чат-бота по сну</strong></div>',
            img: require("../../img/ImageCards/card-image-gray-6.jpg"),
            description:
                '<div>\n' +
                '<h3 >&nbsp;</h3>' +
                '<h3>Наладить сон ребенка </h3> ' +
                '<ul>\n' +
                '<li>на основе одной из четырех методик, обучив самостоятельному засыпанию</li>\n' +
                '<li>избавив от недосыпа всю семью</li>\n' +
                '<li>с наиболее подходящей по возрасту методикой, решая проблемы:\n' +
                '<ul>\n' +
                '<li> раннего пробуждения</li>\n' +
                '<li> бесконечных ночных кормлений</li>\n' +
                '<li> "часовых" укладываний</li>\n' +
                '<li> частых пробуждений</li>\n' +
                '<li> утомительных укачиваний&nbsp;и др.</li>\n' +
                '</ul>\n' +
                '</li>\n' +
                '</ul>' +
                '</div>'
        },
        {
            index: 3,
            linkToTilda: 'https://landing-emo.kornevgmbh.com/',
            title: 'Оставить истерики в прошлом',
            greenTitle: 'Как эффективно управлять эмоциями ребенка',
            subTitle: 'и научится управлять эмоциями ребенка',
            showBF: true,
            img: require("../../img/ImageCards/card-image-gray-9.jpg"),
            description: '<div >\n' +
                '<h3 >&nbsp;</h3>' +
                '<h3 >Курс для вас, если ваш малыш:</h3> ' +
                '<ul>\n' +
                '<li>Уже проявляет яркие эмоции и ему от 5 до 36 месяцев</li>\n' +
                '<li>Не знает и понимает границ</li>\n' +
                '<li>Устраивает истерики дома, на улице или в общественном месте</li>\n' +
                '<li>Кусает , щипает, дергает за волосы и вы не знаете что с этим делать</li>\n' +
                '<li>Не слушается Вас и не реагирует на слова</li>\n' +
                '<li>Проявляет агрессию или плачет по любому поводу</li>\n' +
                '<li>Лезет в опасные места, игнорируя запреты</li>\n' +
                '</ul>' +
                '<p >И если Вы:</p> ' +
                '<ul>\n' +
                '<li>Бессильны при выплеске эмоций ребенка</li>\n' +
                '<li>Чувствуете вину за эмоциональные срывы и крики</li>\n' +
                '<li>Не можете планировать жизнь из-за внезапных эмоциональных реакций ребенка</li>\n' +
                '<li>Испытываете страх перед появлением новых эмоций</li>\n' +
                '<li>Считаете себя плохим родителем</li>\n' +
                '<li>Боитесь посещений общественных мест из-за возможной негативной реакциий ребенка</li>\n' +
                '</ul>' +
                '</div>',
            linkIn: '/emoPageIntro',
            linkLanding: '',
            access: false
        },
        {
            index: 3,
            linkToTilda: 'https://elenakorneva.site/speakLandingSpecial',
            title: 'Усилить  речь ребенка',
            greenTitle: 'доРечевой интенсив',
            subTitle: '<div>с  30-дневным доРечевым интенсивом <strong>"От звука к слову"</strong> - рaзвитие речевого навыка</div>',
            img: require("../../img/ImageCards/card-alfa.png"),
            description: ' <div >\n' +
                '<h3 >&nbsp;</h3>' +
                '<h3 >Этот интенсив для Вас, если:</h3>' +
                '<ul>\n' +
                '<li>Вас волнуют вопросы, связанные с речью вашего малыша, и вы устали от противоречивой и неполной информации в интернете</li>\n' +
                '<li>Вы не готовы &laquo;ждать до 3 лет&raquo;, чтобы после исправлять уже сформировавшиеся проблемы с речью вашего ребенка</li>\n' +
                '<li>Вы сомневаетесь, все ли в порядке с речевым развитием вашего малыша, и не до конца понимаете, что вам делать&nbsp;</li>\n' +
                '<li>Вам важно понимать, как на самом деле устроена речь вашего ребенка, и как работать с ней эффективно и правильно</li>\n' +
                '<li>Ваш малыш родился раньше срока или были проблемы во время беременности или родов</li>\n' +
                '<li>Ваш ребенок растет в семье, где используют два и более языка</li>\n' +
                '</ul>' +
                '<p >С какими проблемами поможет интенсив?</p>' +
                '<ul>\n' +
                '<li>Ребенок не стремится говорить или использовать речь для коммуникации</li>\n' +
                '<li>Малыш ограничивается использованием одного слога или звука вместо полных слов</li>\n' +
                '<li>Ребенок не расширяет свой активный словарь и не повторяет слова, которые слышит</li>\n' +
                '<li>Малыш полагается на жесты или мимику, вместо использования слов для выражения своих потребностей или желаний</li>\n' +
                '<li>Ребенок не реагирует или не отзывается на свое имя, когда его зовут</li>\n' +
                '<li>Малыш испытывает трудности в понимании или выполнении простых инструкций</li>\n' +
                '<li>Ребенок использует ограниченное количество слов и не проявляет стремления произносить новые слова</li>\n' +
                '<li>Малыш произносит отдельные слова, но не способен составить связные фразы или предложения</li>\n' +
                '<li>Ребенок испытывает трудности в установлении речевого контакта и взаимодействии с родителями и сверстниками</li>\n' +
                '<li>Малыш имеет недостаточный уровень речевого развития по сравнению со сверстниками</li>\n' +
                '</ul>' +
                '</div>'
        },

    ]
    return (
        <Container className={"box-center"}>
            <Box  variant="h5" component="div" sx={{display: "flex", justifyContent: 'center'}}>
                N.B. Для прохождения курсов необходим VPN (Телеграм/Youtube)
            </Box>
            {descriptionCourse.map((element, index) =>
                <Box>
                <Card  className={'card-timeline'} key={index}>
                <CardMedia
                sx={{ height: 300}}
                image={element.img}
                title={element.title}
                />
                <CardContent>
                    <Typography variant="body2" color="text.secondary" className={"title-courses"}>
                        {element.title}
                    </Typography>
                    <Typography variant="h5" component="div" className={"h5-size"}
                                dangerouslySetInnerHTML={{__html: element.subTitle}}/>
                    <Typography variant="h5" component="div" className={"description-courses"}
                                dangerouslySetInnerHTML={{__html: element.description}}/>
                </CardContent>
                    <CardActions sx={{display: "flex", justifyContent: 'center'}}>
                        <a href={element.linkToTilda}>
                            <Button className={'timeline-button'}>
                                Перейти</Button>
                        </a>
                    </CardActions>
                </Card>
                </Box>
            )
            }
        </Container>
    );
}
